import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/api/client";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("rk_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("rk_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const sendOtp = async (phone) => {
    const { data } = await api.post("/auth/send-otp", { phone });
    return data;
  };

  const verifyOtp = async (phone, otp, extra = {}) => {
    const { data } = await api.post("/auth/verify-otp", { phone, otp, ...extra });
    localStorage.setItem("rk_token", data.token);
    setUser(data.user);
    return data;
  };

  const checkPhone = async (phone) => {
    const { data } = await api.get("/auth/check-phone", { params: { phone } });
    return data.exists;
  };

  const logout = () => {
    localStorage.removeItem("rk_token");
    setUser(null);
  };

  const updateProfile = async (payload) => {
    const { data } = await api.put("/auth/profile", payload);
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, sendOtp, verifyOtp, checkPhone, logout, updateProfile }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
